<template>
  <div class="footer">
    <div class="home clearfix">
      <div class="left">
        <div class="menu">
          <a href="http://company.drcnet.com.cn/about.html" target="_blank">关于我们</a>|<a
          href="http://company.drcnet.com.cn/cpyc.html" target="_blank">诚聘英才</a>|<a
          href="http://misc.drcnet.com.cn/us/wangzsm.aspx" target="_blank">网站声明</a>|<a
          href="http://company.drcnet.com.cn/lxwm.html" target="_blank">联系我们</a>|<a>设为首页</a>|<a
          href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserSuggestAdd1.aspx" target="_blank">意见和建议</a>|<a
          href="mailto:chiefeditor@drcnet.com.cn">总监信箱</a>
        </div>
        <div class="tel clearfix">
          <img src="http://www.drcnet.com.cn/www/int/images/tel.png" class="left">
          <div class="left">
            <span>热线电话：</span>
            <p>400-7070-678</p>
          </div>
        </div>
        <div class="footer-bottom">Copyright©1998-2019 DRCnet.
          All Rights Reserved&nbsp;版权所有 国研网
        </div>
      </div>
      <div class="right right-box">
        <img src="http://www.drcnet.com.cn/www/int/images/weixin.jpg">
        <p class="font12 mt10">关注国研网公众微信号</p>
      </div>
    </div>
    <div class="bottom-f">
      <div class="home clearfix">
        <ul class="bq">
          <li class="left clearfix font14">
            <span class="left clearfix">京ICP证030059号&nbsp;&nbsp;中关村信用促进会会员证书</span>
            <a href="http://www.hd315.gov.cn/beian/view.asp?bianhao=010202001050900196" target="_blank" class="fl"><img
              src="http://www.drcnet.com.cn/www/int/images/beian.png"></a>
          </li>
          <li class="left clearfix font14">
            <span class="left clearfix">京公网安备 11010102002958号</span>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102002958" target="_blank"
               class="fl"><img src="http://www.drcnet.com.cn/www/int/images/biaoshi.gif"></a>
          </li>
          <li class="right clearfix font14">
            <span>建议浏览器：IE9+、谷歌</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterNav',
};
</script>

<style scoped lang="scss">
.footer{
  color: #fff;
  background: #2b303a;
  height: 290px;
  padding-top: 50px;
  font-size: 16px;
}
.right-box{
  text-align: center;
  width: 122px;
  img{
    width: 110px;
  }
  p{
    color: #797b80;
  }
}
.home{
  width: 1200px;
  margin: 0 auto;
  .menu {
    a{
      padding: 0 10px;
      color: #fff;
    }
  }
  .tel{
    width: 240px;
    padding-top: 50px;
    img{
      padding-right: 15px;
    }
  }
  .footer-bottom {
    padding-top: 20px;
    font-size: 14px;
  }
}
.bottom-f {
  color: #797b80;
  background: #20242c;
  height: 45px;
  line-height: 45px;
  margin-top: 30px;
  img{
    padding-left: 7px;
    padding-top: 12px;
    padding-right: 30px;
  }
}
</style>
